import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface StudioSurfaceProps {
  children: ReactNode;
  className?: string;
}

export function StudioSurface({ children, className }: StudioSurfaceProps) {
  return (
    <div className={cn('bg-card border rounded-xl shadow-sm p-4 lg:p-6', className)}>
      {children}
    </div>
  );
}
